import SearchResults              from 'scripts/defa/search-results/collection-search-results';
import SearchResult               from 'scripts/defa/search-results/model-search-result';
import SearchResultCollectionView from 'scripts/defa/search-results/view-search-result-collection-view';
import SearchResultSnippet        from 'scripts/defa/search-results/view-search-result-snippet';
import Module                     from 'scripts/module';

const SearchResultModule = new Module( 'SearchResultModule', {
	collections: {
		SearchResults
	},
	models     : {
		SearchResult
	},
	views      : {
		SearchResultCollectionView,
		SearchResultSnippet
	}
} );
export default SearchResultModule;